export const SWAL_DEFAULTS = {
    customClass: {
        container: 'sl-swal'
    },
    showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
    },
    hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
    },
    showCloseButton: true,
    showConfirmButton: false,
    scrollbarPadding: false,
}

export const SWAL_ALERT_DEFAULTS = {
    customClass: {
        container: 'sl-swal-alert'
    },
    showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
    },
    hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
    },
    showCloseButton: true,
    scrollbarPadding: false,
}